export default __webpack_public_path__ + "static/media/bhscale_pressed.37f0cdf3.svg";